import script from "./LBFeedMainTopCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./LBFeedMainTopCategory.vue?vue&type=script&setup=true&lang=js"

import "./LBFeedMainTopCategory.vue?vue&type=style&index=0&id=6c62d4ba&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c62d4ba"]])

export default __exports__